export default __webpack_public_path__ + "static/media/Priest's Coils of Sacrifice.dbd80f22.jpg";